const changeTheme = name => {
	if (name) {
		document.body.removeAttribute('class');
		document.body.classList.add(name);
	}
};

const updateTheme = state => {
	changeTheme(state.theme.name);
};

// Hook into theme change to set a inject a selected theme
const ThemePlugin = store => {
	// wait for dom ready
	document.addEventListener('DOMContentLoaded', () => updateTheme(store.state));

	store.subscribe((mutation, state) => {
		if (mutation.type === 'changeTheme') {
			updateTheme(state);
		}
	});
};

export default ThemePlugin;
